// extracted by mini-css-extract-plugin
export default {"layout":"auth-page_layout__5nLlx","box":"auth-page_box__aUJxB","codes":"auth-page_codes__uU-DW","qr":"auth-page_qr__4RfbW"};